/**
 * Native iOS/Android features for Capacitor
 * Push Notifications, Haptics, Share, Biometrics
 */
import { isNativePlatform } from './platform';

// ==================== HAPTIC FEEDBACK ====================
export const hapticImpact = async (style = 'Medium') => {
  if (!isNativePlatform()) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    await Haptics.impact({ style: ImpactStyle[style] || ImpactStyle.Medium });
  } catch (e) {}
};

export const hapticNotification = async (type = 'Success') => {
  if (!isNativePlatform()) return;
  try {
    const { Haptics, NotificationType } = await import('@capacitor/haptics');
    await Haptics.notification({ type: NotificationType[type] || NotificationType.Success });
  } catch (e) {}
};

// ==================== PUSH NOTIFICATIONS ====================
export const initPushNotifications = async () => {
  if (!isNativePlatform()) return;
  try {
    const { PushNotifications } = await import('@capacitor/push-notifications');
    
    const permission = await PushNotifications.requestPermissions();
    if (permission.receive === 'granted') {
      await PushNotifications.register();
      console.log('[Push] Registered for push notifications');
    }

    PushNotifications.addListener('registration', (token) => {
      console.log('[Push] Token:', token.value);
      // TODO: Send token to backend for push targeting
    });

    PushNotifications.addListener('registrationError', (err) => {
      console.error('[Push] Registration error:', err);
    });

    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('[Push] Received:', notification);
    });

    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      console.log('[Push] Action:', action);
    });
  } catch (e) {
    console.error('[Push] Init error:', e);
  }
};

// ==================== NATIVE SHARE ====================
export const nativeShare = async ({ title, text, url }) => {
  if (!isNativePlatform()) {
    // Fallback web share
    if (navigator.share) {
      return navigator.share({ title, text, url });
    }
    return;
  }
  try {
    const { Share } = await import('@capacitor/share');
    await Share.share({ title, text, url, dialogTitle: 'Partager' });
  } catch (e) {
    console.error('[Share] Error:', e);
  }
};
